import Box from '@mui/material/Box';
import { Button } from '@mui/material';
import { Save } from '@mui/icons-material';
import * as Icon from '@mui/icons-material/';

interface HeaderFormActionsProps {
  backActions: () => void;
  duploClick?: boolean;
}

export const HeaderFormActions = ({ backActions, duploClick }: HeaderFormActionsProps) => {
  return (
    <Box className='grid grid-cols-8 gap-5'>
      {/* <IconButton className='col-span-2' onClick={() => backActions()}>
        <ArrowBack />
<<<<<<< Updated upstream
      </IconButton>
      
      <Box className='col-span-6'>
=======
      </IconButton> */}

      <Box className='col-span-2'>
        <Button
          fullWidth
          startIcon={<Icon.ArrowBack />}
          variant='contained'
          color='warning'
          onClick={() => history.back()}
        >
          Voltar
        </Button>
      </Box>
      <Box className='col-span-2'>
        <Button
          fullWidth
          startIcon={<Save />}
          variant='contained'
          color='success'
          //size='large'
          //className='col-span-6'
          type='submit'
          disabled={duploClick}
        >
          Salvar
        </Button>
      </Box>
    </Box>
  );
};
